<template>
  <b-button
      class="button-box m-1 pr-4 d-flex align-items-center"
      variant="outline-secondary"
      @click="emitClick()">
    <slot name="svg"></slot>
    <span style="margin-left: 8px; text-align: left !important;">{{ text }}</span>
  </b-button>
</template>

<script>
export default {
  props: [
    'text'
  ],
  methods: {
    emitClick: function() {
      this.$emit('onClick', event)
      document.querySelectorAll('.button-box.active')[0].classList.remove('active')
      this.$el.classList.add('active')
    }
  }
}
</script>

<style>
  .button-box {
    width: 100%;
    width: -moz-available;  /* WebKit-based browsers will ignore this. */
    height: 60px;
    border: 1px solid #CCCCCC !important;
    box-shadow: #00000008 0 0 6px 0;
    stroke: #888;
    text-align: left;
    display: flex !important;
  }

  .button-box:hover, .button-box:focus, .button-box:active, .button-box:not(:disabled):not(.disabled).active {
    background: url("../assets/sales/active_button_arrow.svg") no-repeat right .75rem center;
    box-shadow: none !important;
    color: #fff !important;
    border-color: #7ABA1E !important;
    stroke: #fff;
    text-align: left;
    display: flex !important;
    background-color: #7ABA1E !important;
  }
</style>
